import { IDesignation } from './../../../../_models/masters/IDesignation';
import { ISchool } from './../../../../_models/account/ISchool';
import { SchoolService } from './../../../../shared/services/school.service';
import { ISetting } from './../../../../_models/cms/ISetting';
import { SettingService } from './../../../../shared/services/setting.service';
import { ISanctionedPost } from './../../../../_models/post-sections/ISanctionedPost';
import { SanctionedPostService } from './../../../../shared/services/sanctioned-post.service';
import { IVacantPost } from './../../../../_models/post-sections/IVacantPost';
import { IKeyValuePair } from './../../../../_models/common/common';
import { CommonService } from './../../../../shared/services/common.service';
import { VacantPostService } from './../../../../shared/services/vacant-post.service';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { MediaFileService } from 'src/app/shared/services/media-file.service';

@Component({
  selector: 'app-vacant-post-form',
  templateUrl: './vacant-post-form.component.html'
})
export class VacantPostFormComponent implements OnInit {

  loading: boolean;
  title: string = 'Add Vacant Post';
  school: ISchool;
  vacantPost: IVacantPost;
  vacantPostForm: FormGroup;
  id;

  regions: IKeyValuePair[];
  states: IKeyValuePair[];
  districts: IKeyValuePair[];
  schools: IKeyValuePair[];
  designations: IDesignation[];
  vacancyTypes: IKeyValuePair[];
  transferCategory: IKeyValuePair[];
  setting: ISetting;

  isShalaId: boolean = false;
  isDeemedDDList: boolean = false;
  isDocument: boolean = false;
  barWidth: number = 0;
  isProgress: boolean = false;
  fileToUpload: File = null;
  private readonly PAGE_SIZE = 10;
  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
  };
  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private service: VacantPostService,
    private commonService: CommonService,
    private sanctionedPostService: SanctionedPostService,
    private mediaFileService: MediaFileService,
    private schoolService: SchoolService,
    private settingService: SettingService) {
    this.id = this.route.snapshot.paramMap.get('id');
    this.settingService.getSetting().then((data: ISetting) => {
      this.setting = data;
      if (!this.setting.isVacancyPrincipal) {
        this.toastrService.warning("vacancy module closed!");
        this.router.navigate(['/']);
      }
      console.log('Promise resolved.');
    });
  }

  ngOnInit() {
    this.bindDropDown();
    this.createVacantPostForm();
    this.schoolService.logged().subscribe((response: ISchool) => {
      if (response) {
        this.school = response;
        this.vacantPostForm.patchValue({
          regionId: this.school.district.state.regionId,
          stateId: this.school.district.stateId,
          districtId: this.school.districtId,
          schoolId: this.school.userId,
        });
        this.getVacantPost();
      }
    });
    this.route.queryParams
    .subscribe(params => {
      this.query.page = isNaN(params.page) ? 1 : params.page;
      this.query.sort = params.sort;
      this.query.sortDir = params.sortDir;
    });
  }

  getVacantPost() {
    if (this.id) this.service.get(this.id).subscribe((response: IVacantPost) => {
      if (response) {
        this.vacantPost = response;
        this.title = 'Edit Vacant Post';
        this.setValueVacantPostForm();
      }
    });
  }

  bindDropDown() {
    this.sanctionedPostService.getDesignations().subscribe((response: IDesignation[]) => {
      if (response) {
        this.designations = response;
      }
    });

    this.commonService.getVacancyTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.vacancyTypes = response;
      }
    });

    this.commonService.getTransferCategoriesVacantPost().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.transferCategory = response;
      }
    });

  }

  setVacantPost() {
    let schoolId = this.vacantPostForm.get("schoolId").value;
    let designationId = this.vacantPostForm.get("designationId").value;
    if (schoolId && designationId) {
      this.sanctionedPostService.find(schoolId, designationId).subscribe((response: ISanctionedPost) => {
        if (response) {
          this.vacantPostForm.patchValue({
            sanctionedPostId: response.id
          });
        }
      });
    }
  }

  createVacantPostForm() {
    this.vacantPostForm = this.fb.group({
      id: ['0'],
      financialYearId: [''],
      regionId: [''],
      stateId: [''],
      districtId: [''],
      schoolId: ['', Validators.required],
      designationId: ['', Validators.required],
      sanctionedPostId: ['', Validators.required],
      vacancyTypeId: ['', Validators.required],
      noOfPost: ['0', Validators.required],
      isActive: [true, Validators.required],
      noOfFilled: ['0', Validators.required],
      documentId: ['0', Validators.required],
      transferCategoryId: ['', Validators.required],
      // shalaId: ['', [Validators.required, Validators.pattern(/^([0-9]{10})([0-9]){0,1}$/)]],
      shalaId: ['', Validators.required],
    });
  }

  setValueVacantPostForm() {
    if (this.vacantPost.vacancyTypeId) {
      this.loadVacancyFields(this.vacantPost.vacancyTypeId)
    }
    if (this.vacantPost.transferCategoryId) {
      this.loadDoc(this.vacantPost.transferCategoryId)
    }
    this.vacantPostForm.patchValue({
      id: this.vacantPost.id,
      financialYearId: this.vacantPost.financialYearId,
      regionId: this.vacantPost.sanctionedPost.school.regionId,
      stateId: this.vacantPost.sanctionedPost.school.stateId,
      districtId: this.vacantPost.sanctionedPost.school.districtId,
      schoolId: this.vacantPost.sanctionedPost.schoolId,
      designationId: this.vacantPost.sanctionedPost.designationId,
      sanctionedPostId: this.vacantPost.sanctionedPostId,
      vacancyTypeId: this.vacantPost.vacancyTypeId,
      noOfPost: this.vacantPost.noOfPost,
      noOfFilled: this.vacantPost.noOfFilled,
      shalaId: this.vacantPost.shalaId,
      documentId: this.vacantPost.documentId,
      transferCategoryId: this.vacantPost.transferCategoryId == null ? '' : this.vacantPost.transferCategoryId,
      isActive: this.vacantPost.isActive
    });
  }

  save() {
    if (this.vacantPostForm.valid) {
      this.loading = true;
      this.vacantPost = Object.assign({}, this.vacantPostForm.value);
      if (this.id) {
        this.service.update(this.id, this.vacantPost).subscribe(() => {
          this.toastrService.success('vacant post updated successful');
          // this.router.navigate(['/school/sanctioned-posts/vacant-posts']);
          this.router.navigate(['/school/sanctioned-posts/vacant-posts'], {
            queryParams: { page: this.query.page },
          });
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
      else {
        this.service.create(this.vacantPost).subscribe(() => {
          this.toastrService.success('vacant post created successful');
          this.router.navigate(['/school/sanctioned-posts/vacant-posts']);
        },
          (error) => console.log('HTTP Error', error),
          () => this.loading = false);
      }
    }
  }

  loadVacancyFields(id) {
    const shalaId = this.vacantPostForm.get('shalaId');
    const documentId = this.vacantPostForm.get('documentId');
    const transferCategoryId = this.vacantPostForm.get('transferCategoryId');

    if (id == '1' || id == '4') {
      this.isShalaId = false;
      this.isDeemedDDList = false;
      this.isDocument = false;

      shalaId.setValidators(null);
      shalaId.setValue(null);

      documentId.setValidators(null);
      documentId.setValue(null);

      transferCategoryId.setValidators(null);
      transferCategoryId.setValue('');
    }
    if (id == '2' || id == '5') {

      // shalaId.setValidators([Validators.required, Validators.pattern(/^([0-9]{10})([0-9]){0,1}$/)]);
      shalaId.setValidators([Validators.required]);
      this.isShalaId = true;
      this.isDeemedDDList = false;
      this.isDocument = false;

      documentId.setValidators(null);
      documentId.setValue(null);

      transferCategoryId.setValidators(null);
      transferCategoryId.setValue('');
    }
    if (id == '3') {

      this.isShalaId = true;
      // shalaId.setValidators([Validators.required, Validators.pattern(/^([0-9]{10})([0-9]){0,1}$/)]);
      shalaId.setValidators([Validators.required]);
      
      this.isDeemedDDList = true;
      documentId.setValidators([Validators.required]);

      this.isDocument = true;
      transferCategoryId.setValidators([Validators.required]);
    }
    shalaId.updateValueAndValidity();
    documentId.updateValueAndValidity();
    transferCategoryId.updateValueAndValidity();
  }
  loadDoc(id) {
    const documentId = this.vacantPostForm.get('documentId');
    if (id == '16') {
      this.isDocument = false;

      documentId.setValidators(null);
      documentId.setValue(null);
    } else {
      this.isDocument = true;
      documentId.setValidators([Validators.required]);

    }
    documentId.updateValueAndValidity();
  }
  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
  }

  OnSubmit(inputDoc) {
    this.mediaFileService.authPostSingleFile(this.fileToUpload).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.isProgress = true;
          this.barWidth = Math.round(event.loaded / event.total * 100);
        }
        else if (event.type === HttpEventType.Response) {
          this.isProgress = false;
          this.barWidth = 0;
          this.vacantPostForm.patchValue({
            documentId: event.body.id
          });
        }
      },
      (error) => {
        console.log(error);
        inputDoc.value = null;
      },
      () => console.log("complete"));
  }
}
